// dropdown for different languages should be used instead
const defaultSelectedLanguageForTextCustomization='en';export default defaultSelectedLanguageForTextCustomization;